import axios from "axios";
import holidays from "../../models/horarios/holidays";
import holidaysPermission from "../../models/permisosDeAcceso/typesHolidays";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getHolidays() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/gferiados`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return holidays.fromJson(item);
        });
      });
  }
  getHolidayPermission(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/dcapermisotiposfer/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return holidaysPermission.fromJson(item);
        });
      });
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      permisoId: items.permissionId,
      tipoFers: items.holidays,
    };

    return axios.post(`${url}/dcapermisotiposfer`, payload, { headers });
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(
      `${url}/dcapermisotiposfer/${data.permissionId}&${data.id}`,
      { headers }
    );
  }
}
export default service;
